import {
  DepartmentListModel,
  DepartmentParams,
} from '../model/systemModel';
import { defHttp } from '/@/utils/http/axios';
import { UploadApiResult } from '../sys/model/uploadModel';
import { useGlobSetting } from '/@/hooks/setting';
import { UploadFileParams } from '/#/axios';
const { uploadUrl = '' } = useGlobSetting();
enum Api {
  getautoLogin = '/autoLogin',
  DeleteExcel = '/excelTemplate/delete',
  UpdateExcel = '/excelTemplate/update',
  getAddExcel = '/excelTemplate/add',
  getExcelList = '/excelTemplate/list',
  getUploadResume = '/recruit/resume/upload',
  DepartmenttreeList = '/department/treeList',
  DeleteDepartment = '/system/role/delete',
  getAutoLoginParam = '/getAutoLoginParam',
  getUserList = '/system/user/list',
  getAdduserList = '/system/user/add',
  getUpdateuserList = '/system/user/update',
  getDateuserList = '/system/user/delete',
  getRoleOwnedUser = '/system/app/getAppOwnerUser',
  getRoleOwned = '/system/role/getRoleOwnedUser',
  getRoleOwnedMenu = '/system/role/getRoleOwnerMenu',
  assignMenusForRole = '/system/role/assignMenusForRole',
  assignUsersForRole = '/system/role/assignUserForRole',
  getUserOwnerRole = '/system/role/getUserOwnerRole',
  RoletreeList = '/system/role/treeList',
  RoleAdd = '/system/role/add',
  RoleUpdate = '/system/role/update',
  RoleList = '/system/role/list',
  getAddountList = '/system/menu/add',
  MenuTreeList = '/system/menu/treeList',
  MenuList = '/system/menu/list',
  UpdateList = '/system/menu/update',
  DateList = '/system/menu/delete',
  getApplicationList = '/system/app/list',
  assignUsersForApp = '/system/app/assignUsersForApp',
  getFormParam = '/system/user/getFormParam',
  getmodifyData = '/modifyData',
  getApplicationAdd = '/system/app/add',
  getApplicationUpdate = '/system/app/update',
  getApplicationDelete = '/system/app/delete',
  assignRolesToUser = '/system/role/assignRolesToUser',
  getlistByRole = '/system/app/listByRole',
  getRoleCopy = '/system/role/copy',
  getUserApp = '/getUserApp',
  getUser = '/user',
  getGameGroup = '/system/game/getGameGroup',
  getRoleOwnerMenu = '/system/user/getUserOwnerMenu',
  getlistByUser = '/system/app/listByUser',
  getassignMenusForUser = '/system/user/assignMenusForUser',
  getUserRoleOwnerMenu = '/system/user/getUserRoleOwnerMenu',
  gettreeListByUser ='/system/menu/treeListByUser',
  getGameGroupList='/system/game/getGameGroup',
  getGameOwnedUser='/system/game/getGameOwnedUser',
  getassignUserForGame='/system/game/assignUserForGame',
  getNameRoleList = '/system/app/nameList',
  getListTreeList = '/system/role/list/treeList',
  getuserListByMenu = '/system/menu/userListByMenu',
  getroleListByMenu = '/system/menu/roleListByMenu',
  getapperrorList = '/system/app/error/log/list',
  getDepartment = '/system/department/getDepartment',
  getRoleOwnerDepartment = '/system/role/getRoleOwnerDepartment',
  getassignDepartmentsForRole= '/system/role/assignDepartmentsForRole',
}


export const getAddountList = (data: Object) =>
  defHttp.post({ url: Api.getAddountList, params: data });

export const getUpdateList = (data: Object) =>
  defHttp.post({ url: Api.UpdateList, params: data });

export const getDateList = (id: number) =>
  defHttp.post({ url: Api.DateList, params: { id } });

export const getMenuList = (data?: Object) =>
  defHttp.get({ url: Api.MenuList, params: data });

export const getlistByRole = (data: Object) =>
  defHttp.get({ url: Api.getlistByRole, params: data });

export const getFormParam = () =>
  defHttp.get({ url: Api.getFormParam });

export const getUser = () =>
  defHttp.get({ url: Api.getUser });

export const getMenuTreeList = (params?: Object) =>
  defHttp.get({ url: Api.MenuTreeList, params });

export const getRoleList = (params?: Object) =>
  defHttp.get({ url: Api.RoleList, params });

export const getUserList = (params?: Object) =>
  defHttp.get({ url: Api.getUserList, params });

export const getAdduserList = (data: Object) =>
  defHttp.post({ url: Api.getAdduserList, params: data });

export const getUpdateuserList = (data: Object) =>
  defHttp.post({ url: Api.getUpdateuserList, params: data });

export const getDateuserList = (id: number) =>
  defHttp.post({ url: Api.getDateuserList, params: { id } });

export const getRoletreeList = (params?: Object) =>
  defHttp.get({ url: Api.RoletreeList, params });

export const getRoleAdd = (data: Object) => defHttp.post({ url: Api.RoleAdd, params: data });

export const getRoleUpdate = (data: Object) => defHttp.post({ url: Api.RoleUpdate, params: data });

export const getRoleCopy = (data: Object) => defHttp.post({ url: Api.getRoleCopy, params: data });

export const getRoleOwnedUser = (app_id: number) =>
  defHttp.get({ url: Api.getRoleOwnedUser, params: { app_id } });

export const getRoleOwned = (role_id: number) =>
  defHttp.get({ url: Api.getRoleOwned, params: { role_id } });

export const assignUsersForRole = (data: Object) =>
  defHttp.post({ url: Api.assignUsersForRole, params: data });

export const getRoleOwnedMenu = (data: Object) =>
  defHttp.get({ url: Api.getRoleOwnedMenu, params: data  });

export const assignMenusForRole = (data: Object) =>
  defHttp.post({ url: Api.assignMenusForRole, params: data });

export const getUserOwnerRole = (user_id: number) =>
  defHttp.get({ url: Api.getUserOwnerRole, params: { user_id } });

export const assignUsersForApp = (data: Object) =>
  defHttp.post({ url: Api.assignUsersForApp, params: data });

export const getautoLogin = (data: Object) =>
  defHttp.get({ url: Api.getautoLogin, params: data });

export const getdeleteExcel = (id: number) =>
  defHttp.post({ url: Api.DeleteExcel, params: { id } });

export const getUpdateExcel = (data: Object) =>
  defHttp.post({ url: Api.UpdateExcel, params: data });

export const getAddExcel = (data: Object) =>
  defHttp.post({ url: Api.getAddExcel, params: data });

export const getExcelList = (params?: Object) =>
  defHttp.get({ url: Api.getExcelList, params });

export const getRoleOwnerMenu = (params?: Object) =>
  defHttp.get({ url: Api.getRoleOwnerMenu, params });

export const getlistByUser = (params?: Object) =>
  defHttp.get({ url: Api.getlistByUser, params });

export const getassignMenusForUser = (data: Object) =>
  defHttp.post({ url: Api.getassignMenusForUser, params: data });

export const getassignDepartmentsForRole = (data: Object) =>
  defHttp.post({ url: Api.getassignDepartmentsForRole, params: data });

export function getUploadResume(
    params: UploadFileParams,
  ) {
    return defHttp.uploadFiles<UploadApiResult>(
      {
        url: uploadUrl+Api.getUploadResume,
      },
      params,
    );
  }


export const getmodifyData = (data: Object) =>
  defHttp.post({ url: Api.getmodifyData, params: data });

export const getApplicationAdd = (data: Object) =>
  defHttp.post({ url: Api.getApplicationAdd, params: data });

export const getApplicationUpdate = (data: Object) =>
  defHttp.post({ url: Api.getApplicationUpdate, params: data });

export const getApplicationDelete = (id: number) =>
  defHttp.post({ url: Api.getApplicationDelete, params: { id } });

export const getApplicationList = (data: Object) =>
  defHttp.get({ url: Api.getApplicationList, params: data });

export const getUserApp = () =>
  defHttp.get({ url: Api.getUserApp });

export const getDepartmenttreeList = (params?: DepartmentParams) =>
  defHttp.get<DepartmentListModel>({ url: Api.DepartmenttreeList, params });

export const getDeleteDepartment = (id: number) =>
  defHttp.post({ url: Api.DeleteDepartment, params: { id } });

export const getAutoLoginParam = (data: Object) =>
  defHttp.get({ url: Api.getAutoLoginParam, params: data });

export const assignRolesToUser = (data: Object) =>
  defHttp.post({ url: Api.assignRolesToUser, params: data });

export const getGameGroup = (data?: Object) =>
  defHttp.get({ url: Api.getGameGroup, params: data });

export const getUserRoleOwnerMenu = (data: Object) =>
  defHttp.get({ url: Api.getUserRoleOwnerMenu, params: data });

export const gettreeListByUser = (data: Object) =>
  defHttp.get({ url: Api.gettreeListByUser, params: data });

export const getGameGroupList = (data: Object) =>
  defHttp.get({ url: Api.getGameGroupList, params: data });

export const getGameOwnedUser = (data: Object) =>
  defHttp.get({ url: Api.getGameOwnedUser, params: data });

export const getassignUserForGame = (data: Object) =>
  defHttp.post({ url: Api.getassignUserForGame, params: data });

export const getNameRoleList = (data?: Object) =>
  defHttp.get({ url: Api.getNameRoleList, params: data });

export const getListTreeList = (data: Object) =>
  defHttp.get({ url: Api.getListTreeList, params: data });

export const getuserListByMenu = (menu_id: number) =>
  defHttp.get({ url: Api.getuserListByMenu, params: { menu_id } });

export const getroleListByMenu = (menu_id: number) =>
  defHttp.get({ url: Api.getroleListByMenu, params: { menu_id } });

export const getapperrorList = (data: Object) =>
  defHttp.get({ url: Api.getapperrorList, params: data });

export const getDepartment = (data: Object) =>
  defHttp.get({ url: Api.getDepartment, params: data });

export const getRoleOwnerDepartment = (data: Object) =>
  defHttp.get({ url: Api.getRoleOwnerDepartment, params: data });
